module.exports = __webpack_public_path__ + "static/media/handle_size_icon.40458e08.JPG";